import React, {useRef, useState} from 'react'

import { Link } from "react-router-dom";

import { Button, Row, Col, Form, Card } from "react-bootstrap";

import header from "../images/headerImage.svg"


import FaceIcon from '@mui/icons-material/Face';
import Face2Icon from '@mui/icons-material/Face2';
import Face4Icon from '@mui/icons-material/Face4';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import RecordVoiceOverIcon from '@mui/icons-material/RecordVoiceOver';
import MenuBookIcon from '@mui/icons-material/MenuBook';

import Footer from "./footer/Footer";

import { collection, serverTimestamp, addDoc } from "firebase/firestore";
import { firestore } from "../firebase/firebase";
import 'firebase/compat/firestore';



import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure();

const LandingPage = () => {
    
    const [success, setSuccess] = useState(null);

    const emailRef = useRef();


  const AlertDismissable = () => {
  
    if (success === true) {
      
      return (
        <div>
          <h6 style={{ color: 'green' }}>
            {`Signed up, thanks!`}
          </h6>

        </div>
          
          
      );

    } else if (success === false) {

      return (
          <h6 style={{color: 'red'}}>Opps, something went wrong!</h6>
      );

    } else {

      return null;

    };
  
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const listRef = collection(firestore, `project watchlist`)

      await addDoc( listRef, {
        createdAt: serverTimestamp(),
        email: emailRef.current.value
        
      });
      
    } catch (error) {

      console.log(error.message);
      setSuccess(false);
      
    } finally {

      toast("Thanks for hanging around!")
      setSuccess(true);

    };

  };
   
      return (
        <div style={{backgroundImage: 'linear-gradient(to bottom, #3B2A9F, #728AB9)', overflow: 'hidden'}}>
          <div style={{padding: '3%'}}>
            <Row>
              <Col>
                <h3 style={{color: "white", marginleft: '5%', textAlign: 'left', fontWeight: '900'}}>Lingo Loco</h3>
              </Col>
              <Col style={{textAlign: 'right'}}>
              <Link to="/levels"><Button
                      sx={{ mt: 1, mr: 1 }}
                      style={{borderColor:'white', color: 'white', marginLeft: '20px'}}
                      variant="outlined"
                    >
                      Dashboard
              </Button></Link>
              <Link to="/languages"><Button
                      variant="contained"
                      sx={{ mt: 1, mr: 1 }}
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #428BC1)', color: 'white', marginLeft: '40px'}}
              >Get started</Button></Link>
              </Col>
            </Row>
            <Row style={{paddingTop: '11%', paddingBottom: '8%', color: 'white'}} data-aos="fade-up" data-aos-duration="1500">
              <Col sm={5}>
                <h1 style={{paddingBottom: '8%', fontWeight: '700'}}>The platform focused on speech and listening to develop your language learning further.</h1>
                <h5  style={{paddingBottom: '8%',}}>Free and no sign up.</h5>
                <Link to="/languages"><Button
                      style={{backgroundImage:'linear-gradient(to left, #ED4CDD, #428BC1)', color: 'white'}}
                      size="lg"
              >Get Started - It's Free!</Button></Link>
              </Col>
              <Col>
              <center>
                  <img style={{maxWidth: '90%'}} src={header}/>
                </center>
              </Col>
            </Row>
            <Row  style={{paddingTop: '6%', paddingBottom: '12%', color: 'white'}} data-aos="fade-up" data-aos-duration="1500">
              <center>
                <h2 style={{paddingBottom: '1%'}}>Hours of gameplay</h2>
                <h5 style={{paddingBottom: '2%'}}>Built to work alongside your learning, whether you have 5 minutes or 5 hours. </h5>
                <Card style={{paddingTop: '6%', paddingBottom: '8%', backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                    <Row>
                    <Col style={{borderRightColor: 'white', borderRight: 'solid'}}>
                    <center>
                      <h4>Multiple Stories</h4>
                      <h6>In each level.</h6>
                      <MenuBookIcon style={{height: '70%'}}/>
                    </center>
                    </Col>
                    <Col  style={{borderRightColor: 'white', borderRight: 'solid'}}>
                    <center>
                      <h4>Multiple Levels</h4>
                      <h6>Added weekly.</h6>
                      <CalendarMonthIcon/>
                    </center>
                    </Col>
                    <Col>
                    <center>
                      <h4>Multiple Languages</h4>
                      <h6>To choose from.</h6>
                      <RecordVoiceOverIcon/>
                    </center>
                    </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </center>
            </Row>
          </div>
            
            <div style={{padding: '3%', marginBottom: '1%', color: 'white'}}> 
              <center data-aos="fade-up" data-aos-duration="1500">
                <h2>How it works</h2>
                <h4>The rules are simple!</h4>
              </center>
              <center>
              <Row style={{padding: '7%', maxWidth: '70%'}} data-aos="fade-up" data-aos-duration="1500">
                <Card style={{backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                    <Row>
                      <Col>
                      <h2>Our gamified learning platform, focused on speech and listening, use a series of stories and conversations resulting in various endings. <br/><br/> Each response results in a different routes the conversation leads.</h2>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Row>
              <Row style={{padding: '7%', color: 'white', maxWidth: '70%'}} data-aos="fade-up" data-aos-duration="1500">
                <Card style={{backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                  <Row>
                      <Col>
                      <h2>The attempted response (1 of the three options) should be said out loud in the language you specified your learning.</h2>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Row>
              <Row style={{padding: '7%', color: 'white', maxWidth: '70%'}} data-aos="fade-up" data-aos-duration="1500">
                <Card style={{backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                  <Row>
                      <Col>
                        <h2>You recieve 3 attempts per response, try all three or recieve specific hints if you attempt the same response more than once.</h2>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Row>
              <Row style={{padding: '7%', color: 'white', maxWidth: '70%'}} data-aos="fade-up" data-aos-duration="1500">
                <Card style={{backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                  <Row>
                      <Col>
                        <h2>If the countdown bar hits 0 it reduces the ammount of attempts you get by 1.</h2>
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Row>
              </center>
            </div>
            <div style={{padding: '3%', marginBottom: '1%', color: 'white'}} data-aos="fade-up" data-aos-duration="1500"> 
              <Row style={{padding: '7%', color: 'white', maxWidth: '100%'}}>
                <Card style={{backgroundColor: '#1D1D41'}}>
                  <Card.Body>
                    <Row>
                      <Col style={{margin: '3%'}}>
                      <h4>Stay in the loop</h4>
                      <h6>Subscribe to receive the latest news and updates. <br/>We'll send you emails for when new levels are released. </h6>
                      </Col>
                      <Col>
                      <form onSubmit={handleSubmit} className="newsBox">
            <input type="email" className="newsInput" ref={emailRef}  placeholder="Enter your email" required/>
            <button type="submit" className="newsBtn">
              Submit
            </button>
          </form>
          {AlertDismissable()}
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>
              </Row>
            </div>
        <Footer/>
        </div>
      );


}

export default LandingPage;


/*
<Row style={{backgroundColor: '#1D1D41', color: 'white', padding: '5%'}} data-aos="fade-up" data-aos-duration="1500">
              <center>
                <h2 style={{paddingTop: '4%'}}>We asked the question; what do you struggle with the most?</h2>
                <h5 style={{paddingTop: '1%'}}>Below are a handful of responses.</h5>
              </center>
              <Col>
                 <Card style={{backgroundColor: '#1D1D41', borderColor: 'white', padding: '5%', margin: '5%'}}>
                  <Card.Body>
                    <Row>
                      <Col sm={2}>
                        <FaceIcon/>
                      </Col>
                      <Col>
                        <Row>
                          <h5>Case Study One</h5>
                        </Row>
                        <Row>
                          <p style={{color: 'grey'}}>Reddit User</p>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <h6>
                      “Easily speaking since I rarely get to practice it. I 'practice' it daily, but that's with pre-written scripts. Talking to a human is unfortunately rare when I'm not travelling.”                      </h6>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card style={{backgroundColor: '#1D1D41', borderColor: 'white', padding: '5%', margin: '5%'}}>
                  <Card.Body>
                    <Row>
                      <Col sm={2}>
                        <Face2Icon/>
                      </Col>
                      <Col>
                        <Row>
                          <h5>Case Study Two</h5>
                        </Row>
                        <Row>
                        <p style={{color: 'grey'}}>Reddit User</p>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <h6>
                      “Speaking and accent, by far. I just started learning Korean and I constantly have to watch videos to see how I should be orienting my mouth and tongue to try to get the right sound. I have the same problem with French. Those sounds just won’t come out of my mouth, lol”                      </h6>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
              <Col>
                <Card style={{backgroundColor: '#1D1D41', borderColor: 'white', padding: '5%', margin: '5%'}}>
                  <Card.Body>
                    <Row>
                      <Col sm={2}>
                        <Face4Icon/>
                      </Col>
                      <Col>
                        <Row>
                        <h5>Case Study Three</h5>
                        </Row>
                        <Row>
                        <p style={{color: 'grey'}}>Reddit User</p>
                        </Row>
                      </Col>
                    </Row>
                    <Row>
                      <h6>
                      “listening,even though I've read 40 novels my listening is very poor,and its so frustrating.”
                      </h6>
                    </Row>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
*/